export type CatalogSearchKind = 'person' | 'studio' | 'legal_entity';

export type CatalogSearchHit =
  | { kind: 'person'; id: string; label: string }
  | { kind: 'studio'; id: string; label: string; subtitle?: string }
  | { kind: 'legal_entity'; id: string; label: string };

export type CatalogManageTabId = 'persons' | 'studios' | 'legal_entities';

export function catalogTabForKind(kind: CatalogSearchKind): CatalogManageTabId {
  switch (kind) {
    case 'person':
      return 'persons';
    case 'studio':
      return 'studios';
    case 'legal_entity':
      return 'legal_entities';
    default: {
      const _exhaustive: never = kind;
      return _exhaustive;
    }
  }
}

export function catalogKindLabel(kind: CatalogSearchKind): string {
  switch (kind) {
    case 'person':
      return 'Персона';
    case 'studio':
      return 'Студия';
    case 'legal_entity':
      return 'Юрлицо';
    default: {
      const _exhaustive: never = kind;
      return _exhaustive;
    }
  }
}
